/**
 * Single source of truth for "should PWA behavior be active on this host".
 *
 * Policy (2026-04-18 — Mustapha decision):
 *   "PWA-ready, but not PWA yet."
 *
 * The product ships the full PWA stack — vite-plugin-pwa builds the
 * Workbox service worker, generates maskable icons, emits offline.html,
 * the <PWAInstallPrompt /> component is wired, UpdateAvailableModal is
 * integrated. Everything is tested. But NO host is allowed to actually
 * register the SW / show the install UI / serve the offline fallback
 * yet — not prod, not staging, not dev, not localhost. The reason is
 * UX safety: we want to reach feature parity and polish before users
 * can install the app and get stuck on a half-ready build. Install +
 * stale-cache issues are the classic PWA hantise.
 *
 * To activate the PWA the day the product is clinically ready:
 *   1. Re-do the favicon as the "b/c" wordmark (current file is just
 *      the slash) and regenerate all icon sizes + splashes.
 *   2. Smoke-test the update flow end-to-end on staging.
 *   3. Add the hostname(s) back to PWA_ALLOWED_HOSTS below.
 *
 * Runtime (not build-time) gate because the same prod bundle runs on
 * every Netlify subdomain; the only way to differentiate is by host.
 */
const PWA_ALLOWED_HOSTS = new Set<string>([
  // INTENTIONALLY EMPTY — see the Policy note above. Flip by adding
  // 'betterclose.io' + 'www.betterclose.io' when ready.
])

export function isPwaHost(): boolean {
  if (typeof window === 'undefined') return false
  return PWA_ALLOWED_HOSTS.has(window.location.hostname)
}
